import { type SelectProps } from '@atlaskit/select';

import { type TemplateOption } from '../../../../../../../controllers/edit/types';

const extraTimingSelectProps: SelectProps<TemplateOption, false> = {
	styles: {
		menuPortal: (base) => ({ ...base, zIndex: 9999 }),
		menuList: (base) => ({
			...base,
			paddingBottom: 0,
		}),
	},
};

export { extraTimingSelectProps };
